/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `claude` - Claude API
 * `suno` - Suno API
 * `openai` - OpenAI API
 * `youtube` - YouTube API
 * `kling` - Kling API
 * `all` - All Services (Monthly Total)
 */
export type ServiceEnum = (typeof ServiceEnum)[keyof typeof ServiceEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ServiceEnum = {
  claude: "claude",
  suno: "suno",
  openai: "openai",
  youtube: "youtube",
  kling: "kling",
  all: "all",
} as const;
